import { ContactType } from "@interfaces/contact.type";

// Define the keys that are common between IContact and conferenceMapping
type ConferenceKeysType = keyof Pick<
  ContactType,
  | "hasAutm2023"
  | "hasAutm2024"
  | "hasBio2022"
  | "hasBio2023"
  | "hasBio2024"
  | "hasLes2023"
  | "hasUidpHbcu2023"
  | "hasUidpMim2023"
>;

/**
 * Returns an object with two properties:
 * 1. attendedConferences: an array of strings representing the conferences the contact has attended
 * 2. tooltipText: a string representing the text to be displayed in the tooltip
 * @param contact - The contact object.
 * @returns - An object containing the attendedConferences and tooltipText properties.
 */
export default function getConferenceAttendance(contact: ContactType) {
  const conferenceMapping: Record<ConferenceKeysType, string> = {
    hasAutm2023: "AUTM 2023",
    hasAutm2024: "AUTM 2024",
    hasBio2022: "BIO 2022",
    hasBio2023: "BIO 2023",
    hasBio2024: "BIO 2024",
    hasLes2023: "LES 2023",
    hasUidpHbcu2023: "UIDP HBCU 2023",
    hasUidpMim2023: "UIDP MIM 2023",
  };

  const attendedConferences = (Object.keys(conferenceMapping) as ConferenceKeysType[])
    .filter((id) => contact[id])
    .map((id) => conferenceMapping[id]);

  const tooltipText = attendedConferences.length > 0 ? `Attended: ${attendedConferences.join(", ")}.` : "";

  return { attendedConferences, tooltipText };
}
